module.exports = __webpack_public_path__ + "img/dataLegalization.d50334f9.png";